<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
                    اپلیکیشن
                    <span v-if="isKarnegasht==true">کارنگاشت </span>
                    <span v-if="isKarnegasht==false">تسکینو </span>
                    <span v-if="isMinVersion==true">نسخه اشتراکی </span>
                </h2>
                <!--<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>-->
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>



            <div class="card card-style mb-3">
                <div class="content">
                    <div class="d-flex">
                        <router-link to="/UserProfile" class="p-0 d-flex align-items-center">
                            <div class="d-flex align-items-center">
                                <i v-if="UserImg==null || UserImg==''" class="fa fa-user-circle color    -green1-dark fa-5x icon-size"></i>
                                <img v-else v-bind:src="UserImg" alt="userProfileImg" width="65" height="65" class="img-fluid rounded-circle" />
                            </div>
                        </router-link>
                        <div class="d-flex flex-column justify-content-start mr-3">
                            <h1 class="font-weight-bolder font-16 line-height-m m-0">{{UserFullName}}</h1>
                            <div v-if="isMinVersion==true" class="d-flex line-height-m">
                                <span class="ml-1">اعتبار حساب تا :</span>
                                <span class="d-inline-block ltr">{{expireDate}}</span>
                            </div>
                            <div class="line-height-m">امروز: {{todayDate}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!--کار نگاشت-->
            <div class="text-center bg-transparent mt-2" v-if="isKarnegasht==true">
                <div class="row m-0 landingPage-mainDiv landingPage-icon-effect-01">
                    <!--<button data-menu="HelpMenu" class="col-3 p-0 bg-transparent mb-3 d-flex flex-column align-items-center ">
                    <div class="icon icon-xxl rounded-m landingPage-icon-wrapper">
                        <span class="blob-1"></span>
                        <span class="blob-3"></span>
                        <span class="landingPage-ico Help-flat-ico"></span>
                    </div>
                    <p class="mb-0">راهنما</p>
                </button>-->
                    <button data-menu="HelpMenu" class="col-3 p-0 bg-transparent mb-3 d-flex flex-column align-items-center">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico help-ico"></span>
                        </div>
                        <p class="mb-0">راهنما</p>
                    </button>
                    <router-link v-if="OtherWorkTypeAccess=='1' || ( isMinVersion==true && isFreeRegist!==true)" to="/OtherWorkTypeList" class="col-3 p-0 mb-3">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico OtherWorkType-ico"></span>
                        </div>
                        <p class="mb-0">نوع فعالیت</p>
                    </router-link>
                    <router-link to="/ProjectList" class="col-3 p-0 mb-3">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico Projects-ico"></span>
                        </div>
                        <p class="mb-0">پروژه ها</p>
                    </router-link>
                    <router-link to="/WorkGroupList" class="col-3 p-0 mb-3">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico WorkGroup-ico"></span>
                        </div>
                        <p class="mb-0">کارگروه</p>
                    </router-link>

                    <!----admin-->
                    <router-link to="/OrgJobList" class="col-3 p-0 mb-3" v-if="isFreeRegist!==true && isAdmin==true">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico OrgJob-ico"></span>
                        </div>
                        <p class="mb-0">چارت سازمانی</p>
                    </router-link>

                    <!----user-->
                    <router-link to="" class="col-3 p-0 mb-3" v-if="!(isFreeRegist!==true && isAdmin==true)">
                        <div class="icon icon-xxl rounded-m disabledlandingPageIcon">
                            <span class="landingPage-ico OrgJob-ico"></span>
                        </div>
                        <p class="mb-0">چارت سازمانی</p>
                    </router-link>

                    <router-link to="/TaskNoteList" class="col-3 p-0 mb-3" v-if="isFreeRegist!==true">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico TaskNote-ico"></span>
                        </div>
                        <p class="mb-0">یادداشت‌ ها</p>
                    </router-link>
                    <router-link to="/WorkTimerList" class="col-3 p-0 mb-3" v-if="isFreeRegist!==true">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico WorkTimer-ico"></span>
                        </div>
                        <p class="mb-0">زمان سنج</p>
                    </router-link>
                    <router-link to="/PinList" class="col-3 p-0 mb-3" v-if="isMinVersion==true">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico PinList-ico"></span>
                        </div>
                        <p class="mb-0">نشان شده</p>
                    </router-link>
                </div>


                <div class="row m-0 landingPage-mainDiv landingPage-icon-effect-01">
                    <template v-if="isMinVersion==true">
                        <!----admin-->
                        <button @click.prevent="InsertAutoPlanAssign" class="col-3 p-0 mb-3" v-if="isFreeRegist || isAdmin==true" style="background-color:transparent!important">
                            <div class="icon icon-xxl rounded-m">
                                <span class="landingPage-ico Order-ico"></span>
                            </div>
                            <p class="mb-0">خرید اشتراک</p>
                        </button>

                        <!----user-->
                        <button @click.prevent="" class="col-3 p-0 mb-3" v-if="!(isFreeRegist || isAdmin==true)" style="background-color:transparent!important">
                            <div class="icon icon-xxl rounded-m disabledlandingPageIcon">
                                <span class="landingPage-ico Order-ico"></span>
                            </div>
                            <p class="mb-0">خرید اشتراک</p>
                        </button>


                        <!----admin-->
                        <button @click.prevent="GoToSmsRecharge" v-if="isFreeRegist==false && isAdmin==true" class="col-3 p-0 mb-3" style="background-color:transparent!important">
                            <div class="icon icon-xxl rounded-m">
                                <span class="landingPage-ico SmsRecharge-ico"></span>
                            </div>
                            <p class="mb-0">شارژ پیامک</p>
                        </button>
                        <!----user-->
                        <button @click.prevent="" v-if="!(isFreeRegist==false && isAdmin==true)" class="col-3 p-0 mb-3" style="background-color:transparent!important">
                            <div class="icon icon-xxl rounded-m disabledlandingPageIcon">
                                <span class="landingPage-ico SmsRecharge-ico"></span>
                            </div>
                            <p class="mb-0">شارژ پیامک</p>
                        </button>

                    </template>
                    <!----admin-->
                    <router-link to="/LocalUserList" class="col-3 p-0 mb-3" v-if="isFreeRegist!==true && isAdmin==true">
                        <div class="icon icon-xxl rounded-m color-magenta2-light">
                            <span class="landingPage-ico LocalUserList-ico"></span>
                        </div>
                        <p class="mb-0">لیست کاربران</p>
                    </router-link>

                    <!----user-->
                    <router-link to="" class="col-3 p-0 mb-3" v-if="!(isFreeRegist!==true && isAdmin==true)">
                        <div class="icon icon-xxl rounded-m color-magenta2-light disabledlandingPageIcon">
                            <span class="landingPage-ico LocalUserList-ico"></span>
                        </div>
                        <p class="mb-0">لیست کاربران</p>
                    </router-link>

                    <router-link to="/InviteUser" class="col-3 p-0 mb-3" v-if="isMinVersion==true">
                        <div class="icon icon-xxl rounded-m color-yellow1-dark">
                            <span class="landingPage-ico InviteUser-ico"></span>
                        </div>
                        <p class="mb-0">دعوت به کارگروه</p>
                    </router-link>

                    <!----admin-->
                    <router-link to="/DeleteUserList" class="col-3 p-0 mb-3" v-if="isFreeVersion==false && isAdmin==true">
                        <div class="icon icon-xxl rounded-m color-red2-dark">
                            <span class="landingPage-ico DeleteUser-ico"></span>
                        </div>
                        <p class="mb-0">حذف حساب کاربری</p>
                    </router-link>

                    <!----user-->
                    <router-link to="#" class="col-3 p-0 mb-3" v-if="!(isFreeVersion==false && isAdmin==true)">
                        <div class="icon icon-xxl rounded-m color-red2-dark disabledlandingPageIcon">
                            <span class="landingPage-ico DeleteUser-ico"></span>
                        </div>
                        <p class="mb-0">حذف حساب کاربری</p>
                    </router-link>
                </div>

                <div class="row m-0 landingPage-mainDiv landingPage-icon-effect-01">

                    <router-link v-if="isMinVersion==false && PersonAccess=='1'" to="/PersonList" class="col-3 p-0 mb-3">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico Person-ico"></span>
                        </div>
                        <p class="mb-0">اشخاص و موسسات</p>
                    </router-link>

                </div>

            </div>


            <!--تسکینو-->
            <div class="text-center bg-transparent mt-2" v-if="isKarnegasht==false">
                <p class="text-right mb-2 font-20 px-4 font-800">ابزار</p>
                <div class="row m-0 landingPage-mainDiv landingPage-icon-effect-01">
                    <button data-menu="HelpMenu" class="col-3 p-0 bg-transparent mb-3 d-flex flex-column align-items-center">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico help-ico"></span>
                        </div>
                        <p class="mb-0">راهنما</p>
                    </button>
                    <router-link to="/OrgUnitReport" class="col-3 p-0 mb-3" v-if="isMinVersion==true || TaskAccess=='1'">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico chart-ico"></span>
                        </div>
                        <p class="mb-0">وضعیت {{lableText('TasksName')??'وظایف'}}</p>
                    </router-link>
                    <router-link to="/ProjectList" class="col-3 p-0 mb-3">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico Projects-ico"></span>
                        </div>
                        <p class="mb-0">پروژه ها</p>
                    </router-link>
                    <router-link to="/ReminderList" class="col-3 p-0 mb-3">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico Reminder-ico"></span>
                        </div>
                        <p class="mb-0">یادآورها</p>
                    </router-link>
                    <router-link to="/TaskNoteList" class="col-3 p-0 mb-3" v-if="isFreeRegist!==true">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico TaskNote-ico"></span>
                        </div>
                        <p class="mb-0">یادداشت‌ ها</p>
                    </router-link>
                    <router-link to="/ConversationList" class="col-3 p-0 mb-3" v-if="isFreeRegist!==true">
                        <div class="icon icon-xxl rounded-m color-orange-light">
                            <span class="landingPage-ico Conversation-ico"></span>
                        </div>
                        <p class="mb-0">گفتگو</p>
                    </router-link>
                    <router-link to="/TaskCloseRequestList" class="col-3 p-0 mb-3" v-if="isMinVersion==true || TaskAccess=='1'">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico TaskCloseRequest-ico"></span>
                        </div>
                        <p class="mb-0">کارتابل</p>
                    </router-link>
                    <router-link to="/UserPresenceList" class="col-3 p-0 mb-3" v-if="isFreeRegist!==true">
                        <div class="icon icon-xxl rounded-m color-pink2-dark">
                            <span class="landingPage-ico UserPresence-ico"></span>
                        </div>
                        <p class="mb-0">حضور غیاب</p>
                    </router-link>
                    <router-link to="/WorkTimerList" class="col-3 p-0 mb-3" v-if="isFreeRegist!==true">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico WorkTimer-ico"></span>
                        </div>
                        <p class="mb-0">زمان سنج</p>
                    </router-link>
                    <router-link to="/showUsersonMap" class="col-3 p-0 mb-3" v-if="isFreeRegist!==true">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico showUsersonMap-ico"></span>
                        </div>
                        <p class="mb-0">موقعیت‌ ها</p>
                    </router-link>
                    <router-link to="/VacationList" class="col-3 p-0 mb-3">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico Vacation-ico"></span>
                        </div>
                        <p class="mb-0">درخواست مرخصی</p>
                    </router-link>
                    <router-link to="/NoticeMassageUserList" class="col-3 p-0 mb-3">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico NoticeMassage-ico"></span>
                        </div>
                        <p class="mb-0">اعلان و رویدادها</p>
                    </router-link>
                    <router-link to="/EvantsList" class="col-3 p-0 mb-3">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico Events-ico"></span>
                        </div>
                        <p class="mb-0">رویدادها</p>
                    </router-link>
                    <router-link to="/PinList" class="col-3 p-0 mb-3" v-if="isMinVersion==true">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico PinList-ico"></span>
                        </div>
                        <p class="mb-0">نشان شده</p>
                    </router-link>
                </div>

                <p v-if="isMinVersion==true && isAdmin==true" class="text-right mb-2 font-20 px-4 font-800">مدیریت</p>
                <div class="row m-0 landingPage-mainDiv landingPage-icon-effect-01">
                    <template v-if="isMinVersion==true">
                        <button @click.prevent="InsertAutoPlanAssign" class="col-3 p-0 mb-3" v-if="isFreeRegist || isAdmin==true" style="background-color:transparent!important">
                            <div class="icon icon-xxl rounded-m">
                                <span class="landingPage-ico Order-ico"></span>
                            </div>
                            <p class="mb-0">خرید اشتراک</p>
                        </button>
                        <button @click.prevent="GoToSmsRecharge" v-if="isFreeRegist==false && isAdmin==true" class="col-3 p-0 mb-3" style="background-color:transparent!important">
                            <div class="icon icon-xxl rounded-m">
                                <span class="landingPage-ico SmsRecharge-ico"></span>
                            </div>
                            <p class="mb-0">خرید پیامک</p>
                        </button>

                    </template>
                    <router-link to="/LocalUserList" class="col-3 p-0 mb-3" v-if="isFreeRegist!==true && isAdmin==true">
                        <div class="icon icon-xxl rounded-m color-magenta2-light">
                            <span class="landingPage-ico LocalUserList-ico"></span>
                        </div>
                        <p class="mb-0">لیست کاربران</p>
                    </router-link>

                    <router-link to="/OrgJobList" class="col-3 p-0 mb-3" v-if="isFreeRegist!==true && isAdmin==true">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico OrgJob-ico"></span>
                        </div>
                        <p class="mb-0">چارت سازمانی</p>
                    </router-link>
                    <router-link to="/DeleteUserList" class="col-3 p-0 mb-3" v-if="isFreeVersion==false && isAdmin==true">
                        <div class="icon icon-xxl rounded-m color-red2-dark">
                            <span class="landingPage-ico DeleteUser-ico"></span>
                        </div>
                        <p class="mb-0">حذف حساب کاربری</p>
                    </router-link>
                </div>



                <p class="text-right mb-2 font-20 px-4 font-800">اطلاعات پایه</p>
                <div class="row m-0 landingPage-mainDiv landingPage-icon-effect-01">
                    <router-link to="/WorkGroupList" class="col-3 p-0 mb-3">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico WorkGroup-ico"></span>
                        </div>
                        <p class="mb-0">کارگروه</p>
                    </router-link>
                    <router-link v-if="isMinVersion==false && PersonAccess=='1'" to="/PersonList" class="col-3 p-0 mb-3">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico Person-ico"></span>
                        </div>
                        <p class="mb-0">اشخاص و موسسات</p>
                    </router-link>
                    <router-link v-if="TaskTypeAccess=='1'|| (isMinVersion==true && isFreeRegist!==true)" to="/TaskTypeList" class="col-3 p-0 mb-3">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico TaskType-ico"></span>
                        </div>
                        <p class="mb-0">{{lableText('TaskType')??'نوع وظیفه'}}</p>
                    </router-link>
                    <router-link v-if="OtherWorkTypeAccess=='1' || ( isMinVersion==true && isFreeRegist!==true)" to="/OtherWorkTypeList" class="col-3 p-0 mb-3">
                        <div class="icon icon-xxl rounded-m">
                            <span class="landingPage-ico OtherWorkType-ico"></span>
                        </div>
                        <p class="mb-0">نوع فعالیت</p>
                    </router-link>
                    <router-link to="/InviteUser" class="col-3 p-0 mb-3" v-if="isMinVersion==true">
                        <div class="icon icon-xxl rounded-m color-yellow1-dark">
                            <span class="landingPage-ico InviteUser-ico"></span>
                        </div>
                        <p class="mb-0">دعوت به کارگروه</p>
                    </router-link>
                </div>


            </div>
        </div>
        <Help-Menu v-if="isKarnegasht==false" title="معرفی اپلیکیشن تسکینو" keyEn="TaskOnline_Help"></Help-Menu>
        <Help-Menu v-if="isKarnegasht==true" title="معرفی اپلیکیشن کارنگاشت" keyEn="TaskOnline_Help"></Help-Menu>
        <!-- Button trigger modal -->
        <button type="button" style="display:none" class="btn btn-primary" id="btnShowModal" data-toggle="modal" data-target="#exampleModalCenter">
            Launch demo modal
        </button>
        <div class="modal-mask" v-if="hasNoticeMessage">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-body m-0">
                        <slot name="body">
                            <div :id="item.randonId" v-for="item in NoticeMessageList" :key="item.noticeMessageId">
                                <div class="border-1 p-3 mb-3">
                                    <p class="font-weight-bold mb-2 font-16 line-height-l text-justify">
                                        <i class="fa fa-exclamation-triangle text-warning ml-2"></i>
                                        {{item.title}}
                                    </p>
                                    <p class="card-text mb-2 line-height-m font-14 text-justify" v-html="item.description"></p>
                                    <div class="text-left">
                                        <button @click="IRealized(item)" type="button" class="btn btn-xxs btn-success font-weight-bold"><i class="fa fa-check font-10 ml-2"></i>متوجه شدم</button>
                                        <a target="_blank" :href="item.mobileUrl" v-if="!!item.mobileUrl" type="button" class="btn mx-1 btn-xxs btn-warning font-weight-bold text-white"><i class="fa fa-check font-10 ml-2"></i>هدایت به لینک</a>
                                    </div>
                                </div>
                            </div>
                        </slot>
                    </div>
                    <div class="modal-footer py-1 px-2">
                        <slot name="footer">
                            <button type="button" class="btn btn-danger btn-xxs" @click="closeModalNoticeMessageList"><i class="fa fa-times font-10 ml-2"></i>بستن</button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
            </div>
        </transition>
    </div>
    <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header d-flex align-items-center">
                    <span class="modal-title font-weight-bold font-16" id="exampleModalLongTitle">پیام</span>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body m-0 pb-0">
                    <div class="my-3" v-html="taskOnlinePayForFreeMessage">

                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal"><i class="fa fa-times font-10 ml-2"></i>بستن</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Button trigger modal -->
    <button type="button" style="display:none" class="btn btn-primary" id="btnShowModal" data-toggle="modal" data-target="#exampleModalCenter">
        Launch demo modal
    </button>
    <!--<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center"><i class="font-22 fa fa-bars"></i></button>-->
</template>

<script>
    import HelpMenu from '../Components/HelpMenu.vue';
    import router from '../../router';
    export default {
        components: {
            "Help-Menu": HelpMenu
        },
        data() {
            return {
                hasNoticeMessage: false,
                showInBazar: false,
                pageLoading: false,
                taskOnlinePayForFreeMessage: "",
                todayDate: null,
                lst: [],
                expireDate: null
            }
        },
        computed: {
            NoticeMessageList() {
                //var list = this.$store.getters.GetNoticeMessageList;
                //if (list.length > 0)
                //    this.hasNoticeMessage = true;
                return this.lst;
            },
            IsUserAuthenticated() {
                return this.$store.getters.IsUserAuthenticated;
            },
            UserFullName() {
                return this.$store.getters.GetUserFullName;
            },
            isAdmin() {
                return this.$store.getters.GetIsAdmin;
            },
            UserImg() {
                return this.$store.getters.GetUserImg;
            },
            isFreeRegist() {
                return this.$store.getters.GetIsFreeRegist;
            },
            NotificationCount() {
                return this.$store.getters.GetNotificationCount;
            },
            PersonAccess() {
                return this.$store.getters.GetPersonAccess;
            },
            TaskAccess() {
                return this.$store.getters.GetTaskAccess;
            },
            OtherWorkTypeAccess() {
                return this.$store.getters.GetOtherWorkTypeAccess;
            },
            TaskTypeAccess() {
                return this.$store.getters.GetTaskTypeAccess;
            },

        },
        methods: {
            GoToSmsRecharge() {
                if (this.isFreeVersion) {
                    if (this.taskOnlinePayForFreeMessage != null && this.taskOnlinePayForFreeMessage != "") {
                        var btnShowModal = document.getElementById("btnShowModal");
                        btnShowModal?.click();
                    }
                } else {
                    setTimeout(function () { router.push('/SmsRecharge'); }, 100);
                }

            },
            closeModalNoticeMessageList() {
                this.hasNoticeMessage = false;
            },
            IRealized(item) {
                if (item.isNoticeMessage) {
                    this.$http
                        .get("TaskOnline/ViewNoticeMessage2?id=" + item.noticeMessageId)
                        .then((data) => {
                            var res = data.data;
                            if (res.isSuccess) {
                                this.showSuccessMessage(res.message);
                                document.getElementById(item.randonId).innerHTML = "";
                            } else {
                                this.showErrorMessage(res.message);
                            }
                        });

                } else {
                    this.$http
                        .get("TaskOnline/ViewNoticeMessage?id=" + item.noticeId)
                        .then((data) => {
                            var res = data.data;
                            if (res.isSuccess) {
                                this.showSuccessMessage(res.message);
                                document.getElementById(item.randonId).innerHTML = "";
                            } else {
                                this.showErrorMessage(res.message);
                            }
                        });
                }
            },
            GetCurrentDate() {
                this.$http.get("Account/GetCurrenctDateTime")
                    .then(data => {
                        this.todayDate = data.data;

                    });
            },
            InsertAutoPlanAssign() {
                if (this.isFreeVersion) {
                    if (this.taskOnlinePayForFreeMessage != null && this.taskOnlinePayForFreeMessage != "") {
                        var btnShowModal = document.getElementById("btnShowModal");
                        btnShowModal?.click();
                    }
                    return;
                } else {
                    this.pageLoading = true;
                    this.$http.get("TaskOnline/InsertAutoPlanAssign")
                        .then(data => {
                            let res = data.data;
                            this.pageLoading = false;
                            if (res.isSuccess) {
                                if (this.$store.getters.GetIsFreeRegist || this.$store.getters.GetIsAdmin) {
                                    setTimeout(function () { router.push('/Order'); }, 100);
                                }
                                if (!this.$store.getters.GetIsAdmin) {
                                    setTimeout(function () { router.push('/UserOrder'); }, 100);
                                }
                            } else {
                                this.showErrorMessage(res.message);
                            }
                        });
                }

            },
            GetExpireDate() {

                this.$http.get("Account/GetUserExpireDate")
                    .then(data => {
                        this.expireDate = data.data;
                        if (this.expireDate != null && this.expireDate != "")
                            this.expireDate = this.expireDate.substring(0, 10)
                    });

            },
            loadScriptsLanding() {///هرجا به مشکل لود نشدن کاستوم جی اس خوردید این فانگشن رو در سمت متدد اون صفحه بارید و در قسمت کرییت فانگشن رو کال کنید.
                let recaptchaScript = document.createElement("script");
                recaptchaScript.setAttribute("id", "customjsScript")
                recaptchaScript.setAttribute("src", "./assets/scripts/custom.js?");
                var exist = document.getElementById("customjsScript");
                if (exist) {
                    exist.remove();
                }

                document.head.appendChild(recaptchaScript);
            },
            SignOutUser() {
                this.$store.dispatch("SignOutUser");
            },
            GetAccesses() {
                this.$store.dispatch("GetTaskTypeAccessFromServer");
                this.$store.dispatch("GetOtherWorkTypeAccess");
                this.$store.dispatch("GetPersonAccess");
            },
            GetNoticeMessageList() {
                this.$http.get("TaskOnline/GetNoticeMessage")
                    .then(data => {
                        this.lst = data.data;
                        if (this.lst.length > 0)
                            this.hasNoticeMessage = true;

                    });
            }
        },
        created() {
            this.$http
                .get("TaskOnline/GetTaskOnlinePayForFreeMessage")
                .then((data) => {
                    this.taskOnlinePayForFreeMessage = data.data;
                });
            this.GetNoticeMessageList();
            this.loadScriptsLanding();
            //this.$http
            //	.get("Task/GetPayInBazar")
            //	.then((data) => {
            //		var res = data.data;
            //		this.showInBazar = res.isSuccess;
            //	});
            this.GetCurrentDate();
            this.GetExpireDate();
            this.GetAccesses();

        },
        mounted() {

            document
                .querySelectorAll(".menu-box-right")
                .forEach((a) => (a.style.display = "block"));
        },

    }
</script>